import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { map } from 'rxjs/operators';

import { environment } from '@app/environment';

class ApiResponse {
    data: any;
    error : any;
}

@Injectable({
  providedIn: 'root'
})
export class GraphQLService {
    
    constructor(
        private apollo: Apollo
    ) { }
    
    query(options: Apollo.QueryOptions, api: 'ambassador'|'public' = 'ambassador'): Promise<ApiResponse> {
        return new Promise((resolve) => {
            options = this.setContextUri(options, api) as Apollo.QueryOptions;
            
            if(typeof options.fetchPolicy === 'undefined'){
                 options.fetchPolicy = 'no-cache';
            }
           
            this.apollo.query(options).subscribe(
                (response) => {                    
                    resolve({data: response.data, error: null});
                },
                (error) => {                    
                    resolve({data: null, error: error});
                }
            );
        });
    }
    
    mutate(options: Apollo.MutateOptions, api: 'ambassador'|'public' = 'ambassador'): Promise<ApiResponse> {
        return new Promise((resolve) => {
            options = this.setContextUri(options, api) as Apollo.MutateOptions;
            this.apollo.mutate(options).subscribe(
                (response) => {                    
                    resolve({data: response.data, error: null});
                },
                (error) => {                    
                    resolve({data: null, error: error});
                }
            );
        });
    }
    
    setContextUri(options: Apollo.QueryOptions|Apollo.MutateOptions, api: 'ambassador'|'public' = 'ambassador'){
        if(typeof options.context?.uri === 'undefined'){
            let uri = environment.URL_API_BACKEND_GRAPHQL + api;
            if(typeof options.context === 'undefined'){
                options.context = {
                    uri: uri                 
                };
            }
            else{
                options.context.uri = uri;
            }
        }
        return options;
    }
}
